function getBundles(licenceUid) {
  if (global.appBundles && licenceUid in global.appBundles) {
    return global.appBundles[licenceUid];
  } else return null;
}

function setBundles(p) {
  if (!global.appBundles) global.appBundles = {}
  if (!global.appBundles[p.licenceUid]) global.appBundles[p.licenceUid] = {}
  let app = global.appBundles[p.licenceUid]
  if (p.dataReducer && !app.dataReducer) app.dataReducer = p.dataReducer
  if (p.localReducer && !app.localReducer) app.localReducer = p.localReducer
  if (p.sharedReducer && !app.sharedReducer) app.sharedReducer = p.sharedReducer
  if (p.settingReducer && !app.settingReducer) app.settingReducer = p.settingReducer
  if (p.jsx && p.moduleKey) {
    if (!app.modules) app.modules = {}
    const { project } = global.store.getState()
    const module = project.modules[p.licenceUid]?.find(m => m.key === p.moduleKey) || project.appBars?.[p.licenceUid]
    if (module?.buildname && !(module.buildname in app.modules)) {
      app.modules[p.moduleKey + module.buildname] = p.jsx
    }
  }
}

module.exports = {
  ...require("./files"),
  ...require("./icon"),
  getBundles,
  setItem(key, value) {
    if (global.sessionStorage) {
      global.sessionStorage.setItem(key, JSON.stringify(value));
    } else return null;
  },
  getItem(key) {
    if (global.sessionStorage) {
      const item = global.sessionStorage.getItem(key);
      if (item) return JSON.parse(item);
    } return null;
  },
  removeItem(key) {
    if (global.sessionStorage) {
      return global.sessionStorage.removeItem(key);
    } else return null;
  },
  setLocalItem(key, value) {
    if (global.localStorage) {
      global.localStorage.setItem(key, JSON.stringify(value));
    } else return null;
  },
  getLocalItem(key) {
    if (global.localStorage) {
      const item = global.localStorage.getItem(key);
      if (item) {
        try {
          return JSON.parse(item);
        } catch (err) {
          return item;
        }
      }
    } return null;
  },
  removeLocalItem(key) {
    if (global.localStorage) {
      return global.localStorage.removeItem(key);
    } else return null;
  },
  loadBundle(params) {
    setBundles(params)
    return global.store.dispatch({
      type: 'LOAD_BUNDLE',
      licenceUid: params.licenceUid,
      projectUid: params.projectUid,
      moduleKey: params.moduleKey,
      dataReducer: params.dataReducer,
      localReducer: params.localReducer,
      sharedReducer: params.sharedReducer,
      settingReducer: params.settingReducer
    });
  },
  getModule(licenceUid, moduleKey, bundlename) {
    const bundles = getBundles(licenceUid);
    if (bundles && bundles.modules) {
      return bundles.modules[moduleKey + bundlename];
    } else return null;
  },
}
